import { MAX_PIN_LENGTH } from '@/consts';
import { encryptPassword } from '@/core/domain/usecases/passwordUsecase';
import { tryJoin } from '@/core/presenter/controller/JoinController';
import { RouterPath } from '@/routes/RouterPath';
import { useStores } from '@/stores';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function useJoinPinSettingView() {
  const { userStore, presentationStore } = useStores();
  const [pin, setPin] = useState<string>('');
  const [checkPin, setCheckPin] = useState<string>('');
  const [isCheckView, setIsCheckView] = useState<boolean>(false);
  const [isPinCheckFailed, setIsPinCheckFailed] = useState<boolean>(false);
  const [isCompleteModalOpen, setIsCompleteModalOpen] = useState<boolean>(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState<boolean>(false);
  const [failedMessage, setFailedMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  /** 숫자 버튼 클릭 이벤트 */
  const onClickNumberBtn = useCallback(
    async (number: string) => {
      if (isCheckView) {
        if ((checkPin.length || 0) < MAX_PIN_LENGTH) {
          const newCheckPin = checkPin + number;
          setCheckPin(newCheckPin);

          if (newCheckPin.length === MAX_PIN_LENGTH) {
            if (newCheckPin === userStore.pin) {
              setIsLoading(true);

              try {
                const encryptedPassword = await encryptPassword(presentationStore.phoneNumber, userStore.password ?? '');
                const encryptedPin = await encryptPassword(presentationStore.phoneNumber, userStore.pin ?? '');
                const isSuccess = await tryJoin({
                  // countryNumber: cleanString(userStore.country ?? ''),
                  phone: userStore.phone ?? '',
                  name: userStore.name ?? '',
                  password: encryptedPassword,
                  pin: encryptedPin,
                });

                setIsLoading(false);

                if (isSuccess.errorCode === '3000') {
                  setFailedMessage(isSuccess.errorMessage || '회원가입에 실패하였습니다.');
                  setIsFailedModalOpen(true);
                  return;
                }

                console.log('isSuccess', isSuccess);
                if (isSuccess.succed) {
                  setIsCompleteModalOpen(true);
                } else {
                  setFailedMessage('회원가입에 실패하였습니다.');
                  setIsFailedModalOpen(true);
                }
              } catch (error) {
                setIsLoading(false);
                setFailedMessage('회원가입에 실패하였습니다.');
                setIsFailedModalOpen(true);
              }
            } else {
              setIsPinCheckFailed(true);
              setCheckPin('');
            }
          }
        }
      } else {
        if ((pin.length || 0) < MAX_PIN_LENGTH) {
          const newPin = pin + number;
          setPin(newPin);
          userStore.setPin(newPin);

          if (newPin.length === MAX_PIN_LENGTH) {
            setIsCheckView(true);
            setCheckPin('');
          }
        }
      }
    },
    [isCheckView, checkPin, userStore, presentationStore.phoneNumber, pin, navigate],
  );

  /** 삭제 버튼 클릭 이벤트 */
  const OnClickDeleteBtn = useCallback(() => {
    if (isCheckView) {
      setCheckPin(checkPin.slice(0, -1));
    } else {
      setPin(pin.slice(0, -1));
    }
  }, [pin, checkPin, isCheckView]);

  /** 전체 삭제 버튼 클릭 이벤트 */
  const onClickAllClearBtn = useCallback(() => {
    if (isCheckView) {
      setCheckPin('');
    } else {
      setPin('');
    }
  }, [isCheckView]);

  /** 회원가입 완료 모달 확인 버튼 클릭 이벤트 */
  const onClickCompleteConfirm = useCallback(() => {
    setIsCompleteModalOpen(false);
    navigate(RouterPath.LOGIN);
  }, [navigate]);

  /** 회원가입 완료 모달 닫기 버튼 클릭 이벤트 */
  const onClickCompleteClose = useCallback(() => {
    setIsCompleteModalOpen(false);
    navigate(RouterPath.LOGIN);
  }, [navigate]);

  /** 회원가입 실패 모달 확인 버튼 클릭 이벤트 */
  const onClickFailedModalConfirm = useCallback(() => {
    setIsFailedModalOpen(false);
    setFailedMessage('');
    navigate(RouterPath.JOIN);
  }, [navigate]);

  return {
    pin,
    checkPin,
    isCheckView,
    isPinCheckFailed,
    isCompleteModalOpen,
    isFailedModalOpen,
    failedMessage,
    isLoading,
    onClickNumberBtn,
    OnClickDeleteBtn,
    onClickAllClearBtn,
    onClickCompleteConfirm,
    onClickCompleteClose,
    onClickFailedModalConfirm,
  };
}
